
import { RootState } from "@/store/types";
import {ActionTree, Module} from "vuex";
import {DeterminationErrorState} from "@/modules/product_determination_error/types";
import {
    getDeterminationErrorsByItem
} from "@/services/product_determination_error";

const actions: ActionTree<DeterminationErrorState, RootState> = {
    async GET_DETERMINATION_ERRORS_BY_ITEM(_, payload) {
        return await getDeterminationErrorsByItem(payload);
    }
}

export const product_determination_error: Module<DeterminationErrorState, RootState> = {
    actions,
}

